import { render, staticRenderFns } from "./CardRegistrosValidos.vue?vue&type=template&id=978b6e30&scoped=true"
import script from "./CardRegistrosValidos.vue?vue&type=script&lang=js"
export * from "./CardRegistrosValidos.vue?vue&type=script&lang=js"
import style0 from "./CardRegistrosValidos.vue?vue&type=style&index=0&id=978b6e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "978b6e30",
  null
  
)

export default component.exports